<template>
  <div>
    <div v-if="!$store.getters.isKiosk" class="myHead">
      <v-app-bar style="background: transparent; height: 67px;" dark>

        <!--        <v-toolbar style="background: transparent; height: 67px; padding-top: 2px" dark>-->
        <v-btn v-if="!isHome" icon @click.native.passive="goBack" style="flex-grow: 0;">
          <v-icon medium class="myBlack">mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn v-if="isHome" icon @click.native.passive="menuClicked" style="flex-grow: 0;">
          <v-icon medium class="myBlack">mdi-menu</v-icon>
        </v-btn>

        <!--            <div class="d-inline-block pl-1 flex-shrink-1 overflow-hidden fastGrow" v-if="isHome">-->
        <!--                <v-toolbar-title class="pointer text-no-wrap hidden-xs-only" style="width: 90px"-->
        <!--                                 @click="gotoHome">-->
        <!--                    THEURER-->
        <!--                </v-toolbar-title>-->
        <!--            </div>-->
        <!--                v-if="isHome"-->
        <div class="d-inline-block text-left pl-1 flex-shrink-1 overflow-hidden titleFont pointer" @click.passive="gotoHome">
          <img style="height: 50px;margin-top: 5px;" class="mr-2 sharpImage" src="../assets/placeholder6-opti.png">
          <!--                <v-list-item-title>{{$store.getters.storeName}}</v-list-item-title>-->
          <!--                <span>{{$store.getters.storeName}}</span>-->
          <!--                <img style="height: 30px;margin-top: 5px;" class="mr-2" src="../assets/icons/logo_text-w.png">-->
          <!--                <b class="mr-2">THEURER</b>-->
          <!--                <span class="text-no-wrap hidden-xs-only"-->
          <!--            >Schmeckt mir lieber.</span>-->
        </div>
        <!--            <div class="pl-1 flex-shrink-1 overflow-hidden fastGrow titleFont" v-if="!isHome">-->
        <!--                <div class="onliner text-uppercase">{{page | noHtml}}</div>-->
        <!--                &lt;!&ndash;                <v-list-item-title class="text-no-wrap text-uppercase" style="width: auto">&ndash;&gt;-->
        <!--                &lt;!&ndash;                    {{page}}&ndash;&gt;-->
        <!--                &lt;!&ndash;                </v-list-item-title>&ndash;&gt;-->
        <!--            </div>-->


        <!--            <div class="text-center">-->
        <!--                <v-btn class="btn-df accentBtn text-only" rounded icon @click.native.passive="clickSortiment"-->
        <!--                       style="width: auto">-->
        <!--                    &lt;!&ndash;                    <v-icon left medium>mdi-layers</v-icon>&ndash;&gt;-->
        <!--                    <span class="hidden-xs-only mr-2">Zum</span>Sortiment-->
        <!--                    <v-icon right medium>mdi-arrow-right</v-icon>-->
        <!--                </v-btn>-->
        <!--            </div>-->

        <!--            <v-spacer></v-spacer>-->

        <div class="text-right headIcons" style="flex-shrink: 0">
          <!--                <v-btn icon @click.native.passive="gotoHome" class="hidden-xs-only">-->
          <!--                    <v-icon medium>mdi-home</v-icon>-->
          <!--                </v-btn>-->


          <!--            <v-btn icon @click.native.passive="gotoFavs">-->
          <!--                <v-icon medium>mdi-heart-outline</v-icon>-->
          <!--            </v-btn>-->

          <!--            <v-btn icon>-->
          <!--                <v-icon medium>filter_list</v-icon>-->
          <!--            </v-btn>-->

          <!--                <v-badge-->
          <!--                        v-if="numberOfFavs > 0"-->
          <!--                        color="myRed"-->
          <!--                        :content="numberOfFavs"-->
          <!--                        overlap-->
          <!--                        offset-x="20"-->
          <!--                        offset-y="20"-->
          <!--                >-->
          <!--                    <v-btn icon @click.native.passive="gotoFavs">-->
          <!--                        <v-icon medium>mdi-heart-outline</v-icon>-->
          <!--                    </v-btn>-->
          <!--                </v-badge>-->
          <!--                <v-btn icon @click.native.passive="gotoFavs" v-else>-->
          <!--                    <v-icon medium>mdi-heart-outline</v-icon>-->
          <!--                </v-btn>-->

          <v-btn class="rounded100" icon @click.native.passive="gotoHome">
            <v-icon medium class="myBlack">mdi-home</v-icon>
          </v-btn>
          <v-btn class="rounded100" icon v-if="$store.getters.inhouse && $store.state.enableKellnerruf"
                 @click.native.passive="goKellnerruf">
            <img class="dotImg soloInvert" src="../assets/icons/waiter.png">
            <!--                    <v-icon medium class="myBlack">mdi-room-service</v-icon>-->
          </v-btn>
          <v-btn icon class="hidden-xs-only rounded100"
                 v-if="$store.state.enableNews"
                 @click.native.passive="gotoAktuelles">
            <v-icon medium class="myBlack">mdi-alert-decagram</v-icon>
          </v-btn>
          <!--                <v-btn @click="$ebus.$emit('inAppNotify')">Test</v-btn>-->
          <v-btn icon @click.native.passive="gotoFoods">
            <v-icon medium class="myBlack">mdi-silverware-fork-knife</v-icon>
          </v-btn>
          <v-btn icon @click.native.passive="gotoDrinks">
            <!--                    <v-icon medium class="myBlack">mdi-glass-mug</v-icon>-->
            <v-icon medium class="myBlack">mdi-beer</v-icon>
            <!--          <v-icon medium class="myBlack">mdi-bottle-soda-classic</v-icon>-->
            <!--                    <v-icon medium class="myBlack">mdi-glass-wine</v-icon>-->
            <!--                    <v-icon medium>mdi-glass-cocktail</v-icon>-->
          </v-btn>
          <!--        <v-btn class="rounded100" icon @click.native.passive="gotoSortiment">-->
          <!--          <v-icon medium class="myBlack">mdi-baguette</v-icon>-->
          <!--&lt;!&ndash;          <v-icon medium class="myBlack">mdi-baguette-fork-knife</v-icon>&ndash;&gt;-->
          <!--        </v-btn>-->
          <!--        <v-btn icon @click.native.passive="gotoDrinks">-->
          <!--          &lt;!&ndash;                    <v-icon medium class="myBlack">mdi-glass-mug</v-icon>&ndash;&gt;-->
          <!--          <v-icon medium class="myBlack">mdi-bottle-soda-classic</v-icon>-->
          <!--          &lt;!&ndash;                    <v-icon medium class="myBlack">mdi-glass-wine</v-icon>&ndash;&gt;-->
          <!--          &lt;!&ndash;                    <v-icon medium>mdi-glass-cocktail</v-icon>&ndash;&gt;-->
          <!--        </v-btn>-->
          <v-btn icon class="hidden-sm-and-down rounded100" @click.native.passive="goLastOrders">
            <v-icon medium class="myBlack">mdi-history</v-icon>
          </v-btn>

          <!--                <v-btn icon @click.native.passive="gotoSortiment" >-->
          <!--                    <v-icon medium>mdi-silverware-fork-knife</v-icon>-->
          <!--                </v-btn>-->

          <v-badge
            v-if="itemsCount > 0"
            color="#000000"
            :content="itemsCount"
            overlap
            offset-x="20"
            offset-y="20"
            class="cart animated"
          >
            <v-btn class="rounded100" icon @click.native.passive="gotoCart">
              <v-icon medium class="myBlack">mdi-cart</v-icon>
            </v-btn>
          </v-badge>
          <v-btn class="rounded100" icon v-else @click.native.passive="gotoCart">
            <v-icon medium class="myBlack">mdi-cart</v-icon>
          </v-btn>

          <!--                <v-btn v-if="$store.state.showSearchIcon" icon @click.native.passive="triggerSearch">-->
          <!--                    <v-icon medium>mdi-magnify</v-icon>-->
          <!--                </v-btn>-->

          <!--                <v-badge-->
          <!--                        v-if="unreadNews.length > 0"-->
          <!--                        color="#B27C50"-->
          <!--                        :content="unreadNews.length"-->
          <!--                        overlap-->
          <!--                        offset-x="20"-->
          <!--                        offset-y="20"-->
          <!--                        class="hidden-xs-only"-->
          <!--                >-->
          <!--                    <v-btn icon @click.native.passive="gotoNews">-->
          <!--                        <v-icon medium>mdi-bell</v-icon>-->
          <!--                    </v-btn>-->
          <!--                </v-badge>-->
          <!--                <v-btn class="hidden-xs-only" v-else icon @click.native.passive="gotoNews">-->
          <!--                    <v-icon medium>mdi-bell</v-icon>-->
          <!--                </v-btn>-->

          <!--                <v-btn icon @click.native.passive="gotoHome">-->
          <!--                    <v-icon medium class="myBlack">mdi-information-outline</v-icon>-->
          <!--                </v-btn>-->

          <!--            @click.native.passive="clickDots"-->
          <!--                <v-btn icon>-->
          <!--                    <v-menu offset-y-->
          <!--                            transition="slide-y-transition"-->
          <!--                            content-class="dotMenu">-->
          <!--                        <template v-slot:activator="{ on, attrs }">-->
          <!--                            <v-btn-->
          <!--                                    light-->
          <!--                                    icon-->
          <!--                                    v-bind="attrs"-->
          <!--                                    v-on="on"-->
          <!--                            >-->
          <!--                                <v-icon class="myBlack">mdi-dots-vertical</v-icon>-->
          <!--                            </v-btn>-->
          <!--                        </template>-->
          <!--                        <v-list light>-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                        <v-list-item&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                @click=""&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                        >&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                            <v-list-item-icon>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                <v-icon>mdi-heart</v-icon>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                            </v-list-item-icon>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                            <v-list-item-content>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                <v-list-item-title>Item 2</v-list-item-title>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                            </v-list-item-content>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                        </v-list-item>&ndash;&gt;&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            &lt;!&ndash;                            <v-list-item&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                    @click="gotoHome"&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                    v-if="!isHome"&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                    class="hidden-xs-only">&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-home</v-icon>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                    Startseite&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;&ndash;&gt;-->

          <!--                            <v-list-item v-if="$store.state.showInstallPwa"-->
          <!--                                         @click="install"-->
          <!--                            >-->
          <!--                                <v-list-item-title>-->
          <!--                                    <v-icon class="mr-3 myBlack">mdi-exit-to-app</v-icon>-->
          <!--                                    App installieren-->
          <!--                                </v-list-item-title>-->
          <!--                            </v-list-item>-->

          <!--                            &lt;!&ndash;                                                        <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                @click="goAccount"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                v-if="$store.getters.loggedIn">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                            <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                <v-icon class="mr-3 myBlack">mdi-account</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                Account&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                            </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                        </v-list-item>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                                                        <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                @click="signin"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                v-if="!$store.getters.loggedIn">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                            <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                <v-icon class="mr-3 myBlack">mdi-key</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                Anmelden&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                            </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                        </v-list-item>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                                                        <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                @click="register"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                v-if="!hasAccount && !$store.getters.loggedIn">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                            <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                <v-icon class="mr-3 myBlack">mdi-account-plus</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                                Registrieren&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                            </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                                        </v-list-item>&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="goCoupons"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-ticket-percent</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;&lt;!&ndash;                                    <img class="dotImg mr-3" src="../assets/icons/gutschein.png">&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Coupons&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoNews"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title v-if="unreadNews.length > 0">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-badge&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            color="myRed"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            :content="unreadNews.length"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            overlap&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            offset-x="25"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            offset-y="19"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            class=""&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                        <v-btn icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                            <v-icon class="mr-3">mdi-bell</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                        </v-btn>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    </v-badge>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Aktuelles&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title v-else>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-bell</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Aktuelles&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                &lt;!&ndash;<v-icon class="mr-2">mdi-bell</v-icon>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoSettings"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-bullhorn-outline</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Benachrichtigungen&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="goFilialen"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-store</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Filialen&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                         @click="triggerSearch"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-magnify</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Suchen&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoFavs"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-heart</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Meine Favoriten&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoCheckin"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-account-check</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Gästeregistrierung&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoTischreservierung"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-calendar-clock</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Tischreservierung&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                            <v-list-item-->
          <!--                                    @click="gotoHome"-->
          <!--                            >-->
          <!--                                <v-list-item-title>-->
          <!--                                    <v-icon class="mr-3 myBlack">mdi-home</v-icon>-->
          <!--                                    Startseite-->
          <!--                                </v-list-item-title>-->
          <!--                            </v-list-item>-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoOeffnungszeiten"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-clock-outline</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Öffnungszeiten&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--&lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--&lt;!&ndash;                                    @click="gotoAbholzeiten"&ndash;&gt;-->
          <!--&lt;!&ndash;                                    v-if="!$store.getters.inhouse"&ndash;&gt;-->
          <!--&lt;!&ndash;                            >&ndash;&gt;-->
          <!--&lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--&lt;!&ndash;                                    <v-icon class="mr-3 myBlack">mdi-clock-outline</v-icon>&ndash;&gt;-->
          <!--&lt;!&ndash;                                    Abholzeiten&ndash;&gt;-->
          <!--&lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--&lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                            <v-list-item-->
          <!--                                    @click="goLastOrders"-->
          <!--                            >-->
          <!--                                <v-list-item-title>-->
          <!--                                    <v-icon class="mr-3 myBlack">mdi-history</v-icon>-->
          <!--                                    Bestellungen-->
          <!--                                </v-list-item-title>-->
          <!--                            </v-list-item>-->

          <!--                            <v-list-item-->
          <!--                                    @click="share"-->
          <!--                                    v-if="!$store.getters.inhouse"-->
          <!--                            >-->
          <!--                                <v-list-item-title>-->
          <!--                                    <v-icon class="mr-3 myBlack">mdi-share-variant</v-icon>-->
          <!--                                    App mit Freunden teilen-->
          <!--                                </v-list-item-title>-->
          <!--                            </v-list-item>-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="gotoImpressum"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-share-variant</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Impressum&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="menuClicked"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-menu</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Hauptmenü&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->


          <!--                            &lt;!&ndash;                            <v-list-item&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    @click="clickContact"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            >&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <v-icon class="mr-3">mdi-message-text</v-icon>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    Kontaktieren Sie uns&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </v-list-item-title>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-list-item>&ndash;&gt;-->

          <!--                        </v-list>-->
          <!--                    </v-menu>-->
          <!--                </v-btn>-->
        </div>


        <!--        </v-toolbar>-->
      </v-app-bar>

      <install v-if="!$store.getters.inhouse && $store.state.showInstallPwa"></install>
    </div>

    <div v-else-if="!$store.getters.showKioskSplashOnHome" class="myHead kiosk">
      <v-app-bar style="background: transparent; height: 67px;" dark>

        <v-btn v-if="!isHome" icon @click.native.passive="goBack" style="flex-grow: 0;">
          <v-icon medium class="myBlack">mdi-chevron-left</v-icon>
        </v-btn>

        <div class="d-inline-block text-left pl-1 flex-shrink-1 overflow-hidden titleFont pointer" @click.passive="gotoHome">
          <img style="height: 50px;margin-top: 5px;" class="mr-2 sharpImage" src="../assets/placeholder6-opti.png">
        </div>

        <div class="text-right headIcons" style="flex-shrink: 0">

          <div class="mr-5 d-inline-block">
            <TripleClick @triple-click="onCLickReload">
              <div style="border: 1px solid red; color: red; padding: 2px 15px" class="noselect"
                   :class="{invisible: $store.getters.hideSetupButton}"
              >
                NEU LADEN
              </div>
            </TripleClick>
          </div>

          <div class="mr-15 d-inline-block">
            <TripleClick @triple-click="onTripleClickExit">
              <div style="border: 1px solid red; color: red; padding: 2px 15px" class="noselect"
                   :class="{invisible: $store.getters.hideSetupButton}"
              >
                EXIT
              </div>
            </TripleClick>
          </div>

          <div class="mr-15 d-inline-block">
            <TripleClick @triple-click="onTripleClickSetup">
              <div style="border: 1px solid red; color: red; padding: 2px 15px" class="noselect"
                   :class="{invisible: $store.getters.hideSetupButton}"
              >
                SETUP
              </div>
            </TripleClick>
          </div>

          <v-btn class="rounded100" icon @click.native.passive="gotoHome">
            <v-icon medium class="myBlack">mdi-home</v-icon>
          </v-btn>
          <!--          <v-btn class="rounded100" icon v-if="$store.getters.inhouse && $store.state.enableKellnerruf"-->
          <!--                 @click.native.passive="goKellnerruf">-->
          <!--            <img class="dotImg soloInvert" src="../assets/icons/waiter.png">-->
          <!--            &lt;!&ndash;                    <v-icon medium class="myBlack">mdi-room-service</v-icon>&ndash;&gt;-->
          <!--          </v-btn>-->
          <v-btn icon class="hidden-xs-only rounded100"
                 v-if="$store.state.enableNews"
                 @click.native.passive="gotoAktuelles">
            <v-icon medium class="myBlack">mdi-alert-decagram</v-icon>
          </v-btn>
          <v-btn icon @click.native.passive="gotoFoods">
            <v-icon medium class="myBlack">mdi-silverware-fork-knife</v-icon>
          </v-btn>
          <v-btn icon @click.native.passive="gotoDrinks">
            <v-icon medium class="myBlack">mdi-beer</v-icon>
          </v-btn>
          <!--          <v-btn icon class="hidden-sm-and-down rounded100" @click.native.passive="goLastOrders">-->
          <!--            <v-icon medium class="myBlack">mdi-history</v-icon>-->
          <!--          </v-btn>-->

          <v-badge
            v-if="itemsCount > 0"
            color="#000000"
            :content="itemsCount"
            overlap
            offset-x="20"
            offset-y="20"
            class="cart animated"
          >
            <v-btn class="rounded100" icon @click.native.passive="gotoCart">
              <v-icon medium class="myBlack">mdi-cart</v-icon>
            </v-btn>
          </v-badge>
          <v-btn class="rounded100" icon v-else @click.native.passive="gotoCart">
            <v-icon medium class="myBlack">mdi-cart</v-icon>
          </v-btn>
        </div>
      </v-app-bar>
    </div>

    <template v-if="$store.getters.isKiosk">
      <NumberInputDialog code-title="Enter the cashier code" code-subtitle=""
                         :dialog="showExitCodeDialog"
                         :acceptable-codes="['337701']" @close="showExitCodeDialog = false" @validationSuccess="exitCodeSuccess">
      </NumberInputDialog>

      <NumberInputDialog code-title="Enter cashier code" code-subtitle=""
                         :dialog="showCashierCodeDialog"
                         :acceptable-codes="['337701']" @close="showCashierCodeDialog = false"
                         @validationSuccess="cashierCodeSuccess">
      </NumberInputDialog>
    </template>

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
// import * as firebaseUtil from '../firebase/firebaseUtil';
import * as bootstrap from '../vendor/bootstrap'
import * as util from "@/vendor/util";
import Install from "./install";
import TripleClick from "../kiosk/TripokeClick.vue";
import Vue from "vue";
import NumberInputDialog from "../androidkiosk/NumberInputDialog.vue";
import {doReload} from "../vendor/util";

export default {
  components: {NumberInputDialog, TripleClick, Install},
  Name: "AppHead",
  // computed: {
  //     hasFavs() {
  //         return store.getters.favFoods.length > 0;
  //     }
  // },
  data() {
    return {
      showExitCodeDialog: false,
      showCashierCodeDialog: false,
    }
  },
  created() {
    ebus.$on('itemAdded', () => {
      this.anim();
    });
  },
  computed: {
    Vue() {
      return Vue
    },
    isHome() {
      return this.$route.name === 'Home' ||
        (this.$route.name === 'Sortiment' && store.getters.inhouse);
    },
    page() {
      let p = store.getters.page;
      let rn = '';
      if (p.length > 2) {
        rn = p;// p.substring(store.state.brandName.length + 3, p.length);
      } else {
        rn = this.$route.name;
      }
      if (!rn || rn === 'all') {
        rn = store.state.brandName;
      }
      return rn;
    },
    numberOfFavs() {
      return 0;
      // let favFoods = [];
      // let favs = cloneMe(store.getters.favFoods);
      // for (let favFood of favs) {
      //     let foodItem;
      //     if (favFood.type && favFood.type === 'drink') {
      //         favFood = store.getters.getDrinkById(favFood.id);
      //     } else {
      //         favFood = store.getters.getFoodById(favFood.id);
      //     }
      //
      //     if (!foodItem) {
      //         //ignore items that do not exist
      //         continue;
      //     }
      //     // if ('image' in foodItem) {
      //     //     favFood.image = foodItem.image;
      //     // }
      //     favFoods.push(favFood);
      // }
      // // if (favFoods.length === 0) {
      // let lsFavFoods = this.$ls.get('favFoods');
      // if (lsFavFoods) {
      //     let fv = lsFavFoods;
      //     for (let v of fv) {
      //         //ignore items that already exist
      //         if (this.containsItemId(favFoods, v.id)) {
      //             continue
      //         }
      //
      //         let foodItem;
      //         if (v.type && v.type === 'drink') {
      //             foodItem = store.getters.getDrinkById(v.id);
      //         } else {
      //             foodItem = store.getters.getFoodById(v.id);
      //         }
      //
      //         if (!foodItem) {
      //             //ignore items that do not exist
      //             continue;
      //         }
      //         // if ('image' in foodItem) {
      //         //     v.image = foodItem.image;
      //         // }
      //         favFoods.push(v);
      //     }
      // }
      // let result = favFoods.length;
      // store.commit('numberOfFavs', result);
      // return result;
    },
    hasAccount() {
      return bootstrap.hasAccount();
    },
    // unreadNews() {
    //     return store.getters.unreadNews;
    // },
    itemsCount() {
      let i = 0;
      for (let item of store.getters.cartItems) {
        if (item.id.startsWith('special') || item.id.startsWith('stempel-')) {
          continue;
        }
        i += item.count;
      }
      return '' + i;
    },
  },
  methods: {
    onCLickReload() {
      if (store.getters.isAndroidKiosk) {
        ebus.$emit('restartAndroidApp');
      } else {
        doReload('AppHead');
      }
    },
    onTripleClickExit() {
      this.showExitCodeDialog = true;
      setTimeout(() => {
        this.showExitCodeDialog = false;
      }, 8 * 1000);
    },
    exitCodeSuccess() {
      ebus.$emit('doExitKiosk');
    },
    cashierCodeSuccess() {
      this.$router.push({name: 'SetupKiosk'});
    },
    onTripleClickSetup() {
      this.showCashierCodeDialog = true;
      setTimeout(() => {
        this.showCashierCodeDialog = false;
      }, 8 * 1000);
    },
    goBack() {
      if (this.$route.name === 'Bestellung') {
        this.$router.push({name: 'Home'});
      } else {
        ebus.$emit('goBack');
      }
    },
    containsItemId(items, id) {
      for (let item of items) {
        if (item.id === id) {
          return true;
        }
      }
      return false;
    },
    clickContact() {
      ebus.$emit('triggerFeedback');
    },
    clickSortiment() {
      this.$router.push({name: 'Speisekarte'});
    },
    goCoupons() {
      this.$router.push({name: 'Coupons'});
    },
    // goFilialen() {
    //     this.$router.push({name: 'Filialen'});
    // },
    gotoCart() {
      if (this.$route.name === 'Korb') {
        ebus.$emit('toast', 'Du befindest dich bereits im Warenkorb');
      } else {
        this.$router.push({name: 'Korb'});
      }

    },
    gotoSettings() {
      this.$router.push({name: 'Einstellungen'});
    },
    // gotoNews() {
    //     this.$router.push({name: 'Aktuelles'});
    // },
    install() {
      ebus.$emit('installPrompt')
    },
    goAccount() {
      this.$router.push({name: 'Account'});
    },
    signin() {
      this.$router.push({name: 'Anmelden'});
    },
    register() {
      this.$router.push({name: 'Registrierung'});
    },
    share() {
      ebus.$emit('shareApp');
    },
    gotoOeffnungszeiten() {
      this.$router.push({name: 'Oeffnungszeiten'});
    },
    gotoAbholzeiten() {
      this.$router.push({name: 'Abholzeiten'});
    },
    gotoAktuelles() {
      this.$router.push({name: 'Aktuelles'});
    },
    goLastOrders() {
      this.$router.push({name: 'Bestellungen'});
    },
    gotoCheckin() {
      // if (bootstrap.isAndroid) {
      //     ebus.$emit('showInfo', {
      //         title: 'Diese Funktion befindet sich in Arbeit. Bitte manuell registrieren!',
      //         // text: 'Bitte wähle eine Option aus für "' + _variant.title + '"',
      //     });
      // } else {
      //     this.$router.push({name: 'Checkin'});
      // }
    },
    gotoTischreservierung() {
      this.$router.push({name: 'Tischreservierung'});
    },
    // gotoImpressum(){
    //     this.$router.push({name: 'Impressum'});
    // },
    // clickDots() {
    // if (!firebaseUtil.getPushToken()) {
    //     ebus.$emit('showQuestion', {
    //         quest: 'Möchtest du über Statusänderungen zu deiner Bestellung benachrichtigt werden?',
    //         yesAction: 'requestPush',
    //         yesLabel: 'Ja, Zulassen'
    //     })
    // }
    // },
    triggerSearch() {
      ebus.$emit('triggerSearchAnywhere')
    },
    goKellnerruf() {
      this.$router.push({name: 'Kellnerruf'});
    },
    gotoHome() {
      if (this.$route.name === 'Home') {
        if (!store.getters.isKiosk) {
          ebus.$emit('toast', 'Du befindest dich bereits auf der Startseite');
        }
        setTimeout(() => {
          util.jumpToTop()
        }, 140);
        // alert('has fully = '+!!window.fully);
      } else {
        this.$router.push({name: 'Home'});
      }
    },
    gotoSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    gotoFoods() {
      ebus.$emit('shortcutToFoodMenu');
      // this.$router.push({name: 'Speisen'});
    },
    gotoDrinks() {
      ebus.$emit('shortcutToDrinkMenu');
      // this.$router.push({name: 'Getraenke'});
    },
    gotoFavs() {
      this.$router.push({name: 'Favoriten'});
    },
    cancleSearch() {
      ebus.$emit('cancleSearch')
    },

    menuClicked() {
      this.$emit('menu');
    },

    anim() {
      console.log('??? trigger animation now');
      try {
        setTimeout(() => {
          let theCart = document.querySelector('.cart.animated .v-badge__badge');
          this.doTriggerAnimation(theCart);
        }, 50);
      } catch (err) {
        console.log('Error in animation: ' + err);
      }
    },

    doTriggerAnimation(elem) {
      if (elem) {
        elem.classList.remove('cartanimation');
        elem.classList.add('cartanimation');
        setTimeout(() => {
          elem.classList.remove('cartanimation');
        }, 3050);
      }
    },

  }
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.cart ::v-deep .v-badge__badge {
  color: white;
  font-weight: bolder;
}

.dotImg {
  width: 24px;
  height: auto;
  /*display: inline-flex;*/
  /*vertical-align: middle;*/
}

.headIcons {
  ::before {
    font-size: 30px;
  }
}

/*.headIcons ::v-deep i{*/
/*    color: #809AA2 !important;*/
/*}*/
/*.headLeft {*/
/*    color: #808080 !important;*/
/*}*/


.myHead {
  position: fixed;
  z-index: 190;
  top: 0;
  left: 0;
  width: 100%;
  height: $headHeight;
  background-color: $color-primary;
  //background-color: rgba($color-darkblue, 0.9);
  //backdrop-filter: blur(5px);
  @include material-shadow(1);
  /*border-bottom: 1px solid #82ACB7;*/
}

.myHead ::v-deep .v-toolbar__content > * {
  flex-grow: 1;
}

.myHead ::v-deep header {
  overflow: hidden;
}

/*.tablet {*/
/*    .myHead {*/
/*        //background-color: rgba($color-primary, 0.9);*/
/*        //backdrop-filter: blur(5px);*/
/*    }*/
/*}*/

.dotMenu ::v-deep .v-list-item__title {
  font-size: 1.2em;
}

.onliner {
  font-size: 14px;
  font-size: min(max(12px, 2.8vw), 18px);
}

.v-toolbar__title {
  font-weight: 700;
}


</style>
